import styled from "styled-components";
import { StyledGlobalMainContainer } from "../globalStyle";

export const StyledContainer = styled(StyledGlobalMainContainer)`
  padding-top: 114px;
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-column-gap: 151px;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    grid-row-gap: 40px;
  }
  @media (max-width: 768px) {
    padding: 40px 22px;
  }
`;

export const StyledTitleContainer = styled.div`
  display: grid;
  justify-items: center;
  @media (max-width: 768px) {
    background: none;
  }
`;

export const StyledInnerContainer = styled.div`
  display: grid;
  grid-row-gap: 30px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 26px;
  }
`;

export const StyledHeaderContainer = styled.div`
  display: grid;
  grid-row-gap: 18px;
  align-self: start;
  justify-items: start;
`;

export const StyledLeftContainer = styled.div``;

export const StyledRightContainer = styled.div`
  display: grid;
  justify-items: end;
  margin-right: 50px;
`;

export const StyledListItem = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: 33px;
`;

export const StyledInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 53px;
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    grid-row-gap: 33px;
  }
  input{
    background-color: inherit;
  }
`;

export const StyledInputContainerFull = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 53px;
  align-items: center;
  position: relative;
  svg {
    position: absolute;
    right: 0;
  }
  @media (max-width: 576px) {
    margin-top: 0;
  }
  textarea{
    background-color: inherit;
  }
`;

export const StyledButtonContainer = styled.div`
  width: 206px;
  height: 55px;
  margin-top: 16px;
  justify-self: end;
`;

export const StyledDescriptionList = styled.div``;

export const StyledMessage = styled.span`
  font-size: 18px;
  color: ${(p) => (p.success ? "#89C35C" : "#F32013")};
`;

export const StyledDescriptionListItem = styled.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 34px;
  color: #264445;
`;
